import { useZero } from '@/shared/integrations/zero/use-zero'
import { UpdateResourceStatusSchema } from '@cypro/engine/mutators'
import { useCallback } from 'react'

export function useUpdateTradeNameStatus() {
  const zero = useZero()

  return useCallback(
    (payload: UpdateResourceStatusSchema) =>
      zero.attemptMutation(zero.mutators.tradeNames.updateStatus(payload), async mutation => await mutation.server),
    [zero]
  )
}
